import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import DevDeleteOrgStore from './DevDeleteOrgStore'
import Grid from '@mui/material/Grid'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import TextField from '@mui/material/TextField'
import GapDialog from 'reusable/gap-dialog/GapDialog'

export default observer(function DevDeleteOrg() {
   const devUserSearchStore = useStore(() => new DevDeleteOrgStore())

   return <>
      <Grid container gap={1} sx={{ mt: 4 }}>
         <Grid size={9}>
            {devUserSearchStore.formHandler.orgId.bindInput(ip =>
               <TextField
                  autoFocus
                  fullWidth
                  label="Org id"
                  {...ip}
               />)}
         </Grid>
         <Grid size={2}>
            <ButtonWithProgress
               loading={devUserSearchStore.orgLoader.isLoading}
               variant="outlined"
               fullWidth
               sx={{ height: '56px', borderRadius: '8px' }}
               onClick={devUserSearchStore.fetchOrg}>
               Find organisation
            </ButtonWithProgress>
         </Grid>
      </Grid>

      <JsonTable data={devUserSearchStore.org} />

      {devUserSearchStore.org && <>
         <ButtonWithProgress
            loading={devUserSearchStore.orgLoader.isLoading}
            variant="outlined"
            fullWidth
            sx={{ height: '56px', borderRadius: '8px' }}
            onClick={devUserSearchStore.deleteDialog.open}>
            Delete organisation
         </ButtonWithProgress>

         <GapDialog
            modalState={devUserSearchStore.deleteDialog}
            title="Delete advisor org"
            size='small'>

            This action will delete the organisation, including documents / work-items and so-on. Are you sure you want to delete {devUserSearchStore.org.name}? Please fill in the advisor name:

            <Grid container gap={0.5} sx={{ mt: 4 }}>
               <Grid size={9}>
                  {devUserSearchStore.formHandler.orgName.bindInput(ip =>
                     <TextField
                        autoFocus
                        fullWidth
                        label="Org name"
                        {...ip}
                     />)}
               </Grid>
               <Grid size={2.5}>
                  <ButtonWithProgress
                     loading={devUserSearchStore.orgLoader.isLoading}
                     variant="outlined"
                     fullWidth
                     sx={{ height: '56px', borderRadius: '8px' }}
                     disabled={devUserSearchStore.fields.orgName !== devUserSearchStore.org.name}
                     onClick={devUserSearchStore.deleteOrg}>
                     Delete
                  </ButtonWithProgress>
               </Grid>
            </Grid>
         </GapDialog>
      </>}
   </>
})


type JsonToTableProps = {
   data?: Record<string, any>
}

const JsonTable: React.FC<JsonToTableProps> = ({ data }) => {
   if (!data) {
      return null
   }

   return <table>
      <tbody>
         {Object.entries(data).map(([key, value]) => (
            <tr key={key}>
               <td><strong>{key}</strong></td>
               <td>{String(value)}</td>
            </tr>
         ))}
      </tbody>
   </table>
}
